module.exports = __webpack_public_path__ + "img/tree.062503a3.png";